import { IBaseResponse } from '@/lib/apiBase';
import { IPagination, ICommit, TKeyValuePair, IResourceVersion } from '@/types';

interface IDataFrameSize {
  width: number;
  height: number;
}

export const codeLanguageOptions = [
  { label: 'Text', value: 'text' },
  { label: 'Rust', value: 'rust' },
  { label: 'Python', value: 'python' },
  { label: 'JavaScript', value: 'javascript' },
  { label: 'Go', value: 'go' },
  { label: 'Java', value: 'java' },
  { label: 'C', value: 'c' },
  { label: 'C++', value: 'cpp' },
  { label: 'Ruby', value: 'ruby' },
  { label: 'Swift', value: 'swift' },
  { label: 'Kotlin', value: 'kotlin' },
  { label: 'Elixir', value: 'elixir' },
];

interface IDataFrameFieldMetadata {
  _oxen: {
    render: {
      func: 'image' | 'link' | 'code' | 'markdown';
      language?: (typeof codeLanguageOptions)[number]['value'];
    };
  };
}

export type TSchemaDatatype =
  | 'bool'
  | 'uint8'
  | 'u16'
  | 'u32'
  | 'u64'
  | 'i8'
  | 'i16'
  | 'i32'
  | 'i64'
  | 'f32'
  | 'f64'
  | 'str'
  | 'date'
  | 'time'
  | 'list'
  | 'struct'
  | 'null'
  | '?';

type TDataFrameFieldStatus = 'added' | 'deleted' | 'modified' | 'unchanged';

type TDataFrameFieldChanges = {
  status: TDataFrameFieldStatus;
  previous?: IDataFrameField | null;
};
export interface IDataFrameField {
  // dtype: TSchemaDatatype;
  dtype: string;
  metadata: IDataFrameFieldMetadata | null;
  name: string;
  changes?: TDataFrameFieldChanges | null;
}

export type IDataFrameSchema = {
  fields: IDataFrameField[];
  hash: string;
  metadata: any;
  name?: string | null;
};

interface IDataFrameRequestParams {
  namespace: string;
  repo_name: string;
  resource: string[];
  page?: number | string;
  page_size?: number | string;
  randomize?: boolean;
  reverse?: boolean;
  sort_by?: string;
  nlp?: string;
  sql?: string;
}

type TOptsName =
  | 'text2sql'
  | 'sql'
  | 'unique'
  | 'should_randomize'
  | 'sort_by'
  | 'should_reverse'
  | 'take'
  | 'slice'
  | 'head'
  | 'tail';

interface IDataFrameOptsEntry {
  name: TOptsName;
  value: string | null;
}

interface IDataFrameViewSummary {
  schema: IDataFrameSchema;
  size: IDataFrameSize;
}

export interface IDataFrameView extends IDataFrameViewSummary {
  data: TKeyValuePair[];
  opts?: IDataFrameOptsEntry[];
  pagination: IPagination;
}

interface IDataFrameQuery {
  nlp?: string;
  sql?: string;
  daily_total: number;
  has_hit_limit: boolean;
  user_limit: number;
}

interface IDataFrame {
  query: IDataFrameQuery; // TODO: Deprecated?
  source: IDataFrameViewSummary;
  view: IDataFrameView;
}

export interface IDataFrameResponse extends IBaseResponse {
  commit: ICommit;
  data_frame: IDataFrame;
  oxen_version: string;
  request_params: IDataFrameRequestParams;
  resource: IResourceVersion;
  status_description?: string;
}
